import { defaultHttpClient } from '../../httpClient';
import type { GoodsDiscountsResponse } from './types';

export const getGoodsDiscounts = (goodsId: number) => {
  return defaultHttpClient
    .request<GoodsDiscountsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsId}/discounts/`,
    })
    .then(result => result.data);
};
